import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import { RankingItem, WaHelperService } from 'world-archery-lib';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: '[app-wcup-rannking-item]',
  templateUrl: './wcup-rannking-item.component.html',
  styleUrls: ['./wcup-rannking-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WCupRannkingItemComponent extends DrupalLangClass implements OnInit {
  @Input()
  Ranking: RankingItem = {} as any;
  showDetails = false;

  constructor(
    public helper: WaHelperService,
    injector: Injector,
  ) {
    super(injector);

  }

  ngOnInit() {

  }
  onClick() {
    this.showDetails = !this.showDetails;
  }
  parseRank(rank: number, rankOld: number): string {
    if (rankOld == null) {
      return 'New';
    }
    let number = 0;

    if (rank > rankOld) {
      number = rank - rankOld;
    }
    if (rank < rankOld) {
      number = rankOld - rank;
    }
    if (rank === rankOld) {
      return '';
    }
    return rank < rankOld
      ? '+'.concat(number.toString())
      : '-'.concat(number.toString());
  }
  getClass(rank: number, rankOld: number) {
    if (rankOld == null) {
      return 'NEW';
    }
    if (rank < rankOld) {
      return 'up';
    }
    if (rank > rankOld) {
      return 'down';
    }
    if (rank === rankOld) {
      return 'equal';
    }
  }
  getNameCountry(country: string) {
    return this.helper.getCountryNamesInfo(country).short;
  }
  getStatus(status: number): string {
    switch (status) {
      case 0:
        return 'Qualified';
      case 3:
        return 'Third athlete';
      case 4:
        return 'Not qualified';
      case 5:
        return 'Qualified';
    }
  }
}
